import React from 'react';

const PaymentMethodView = () => {
  return (
    <div className="row">
      <div className="col-xs-16 col-sm-offset-2 col-sm-12 payment-method-view-container">
        <div className="payment-method-view-mastercard"></div>
        <div className="payment-method-view-visa"></div>
        <div className="payment-method-view-sofort-uberweisung"></div>
        <div className="payment-method-view-ideal"></div>
        <div className="payment-method-view-paypal"></div>
        <div className="payment-method-view-postepay"></div>
        <div className="payment-method-view-bank-transfer"></div>
        <div className="payment-method-view-alipay-worldpay"></div>
      </div>
    </div>
  );
}

export default PaymentMethodView;
